import {
  Pagination as MuiPagination,
  PaginationItem,
  PaginationProps as MuiPaginationProps,
} from "@mui/material";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { FC } from "react";

type CustomPaginationProps = MuiPaginationProps;

const Pagination: FC<CustomPaginationProps> = ({
  page = 1,
  renderItem,
  ...props
}) => {
  const defaultRenderItem: MuiPaginationProps["renderItem"] = (item) => {
    if ((item.type === "previous" || item.type === "first") && page === 1) {
      return null;
    }

    if (item.type === "first" && page < 3) {
      return null;
    }

    return (
      <PaginationItem
        {...item}
        slots={{
          first: SkipPreviousIcon,
          last: SkipNextIcon,
        }}
      />
    );
  };

  return (
    <MuiPagination
      shape="rounded"
      color="primary"
      showFirstButton
      showLastButton
      page={page}
      renderItem={renderItem ?? defaultRenderItem}
      {...props}
    />
  );
};

export default Pagination;
